// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAV60mVD-bFpMYjyr4q642j1k6JQJ9gmDM",
    authDomain: "scgm-po.firebaseapp.com",
    databaseURL: "https://scgm-po.firebaseio.com",
    projectId: "scgm-po",
    storageBucket: "scgm-po.appspot.com",
    messagingSenderId: "663822936952",
    appId: "1:663822936952:web:f17dcb6b86d5f55cbd368d",
    measurementId: "G-SBN84HCKK6"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
